import { render, staticRenderFns } from "./Shuttles.vue?vue&type=template&id=6b35945c"
import script from "./Shuttles.vue?vue&type=script&lang=js"
export * from "./Shuttles.vue?vue&type=script&lang=js"
import style0 from "./Shuttles.vue?vue&type=style&index=0&id=6b35945c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports